<template>
  <div class="main-body">
    <div class="header">充值列表</div>
    <div class="out">

      <div class="search2">


        <div style="float:right">

          <el-select v-model="governmentCode" placeholder="请选择政府"
                     style="margin-right:10px">
            <el-option
                v-for="item in governmentValue"
                :key="item.governmentCode"
                :label="item.name"
                :value="item.governmentCode">
            </el-option>
          </el-select>

          <el-input v-model="elderlyName" placeholder="选择老人" disabled style="width: 250px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>
          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>

      </div>

      <el-table class="table" size="mini" :data="tableData" v-loading="loading"
                :height="th" border>

        <el-table-column fixed label="老人姓名" prop="elderly.name" width="100"></el-table-column>
        <el-table-column label="手机号" prop="elderly.phone" width="110"></el-table-column>
        <el-table-column label="身份证号" prop="elderly.idCard" width="180"></el-table-column>


        <el-table-column prop="addBalance" label="充值金额" width="100"></el-table-column>
        <el-table-column prop="beforeBalance" label="充值前金额" width="100"></el-table-column>
        <el-table-column prop="afterBalance" label="充值后金额" width="100"></el-table-column>

        <el-table-column prop="rechargeType" label="充值类型" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.rechargeType == 1">现金</span>
            <span v-if="scope.row.rechargeType == 2">支付宝</span>
            <span v-if="scope.row.rechargeType == 3">微信</span>
            <span v-if="scope.row.rechargeType == 4">刷卡</span>
            <span v-if="scope.row.rechargeType == 5">补贴</span>
            <span v-if="scope.row.rechargeType == 6">转账</span>
          </template>
        </el-table-column>
        <el-table-column prop="remarks"  label="备注" width="150"></el-table-column>

        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="充值时间"></el-table-column>

        <!--              <el-table-column prop="balance" label="余额" width="150"></el-table-column>-->

        <el-table-column label="地区" prop="elderly.areaName" width="150"></el-table-column>
        <el-table-column label="详细地址" prop="elderly.homeAddress" width="250"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Elderly ref="myElderly" v-show="showModalGetElderly"
             v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>


  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


import Elderly from "@/views/Elderly/Comm/ElderlyGov2";


export default {
  name: "Role",
  data(){
    return{
      loading:true,

      showModalAdd:false,
      voucherDialog:false,

      showModalGetElderly:false,
      showModalAddMul:false,

      elderlyCode:'',
      elderlyName:'',

      rechargeType:-1,



      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,


      rechargeType_arr:[
        {value:1,label:"现金"},
        {value:2,label:"支付宝"},
        {value:3,label:"微信"},
        {value:4,label:"刷卡"},
        {value:5,label:"补贴"},
        {value:6,label:"转账"}
      ],

      governmentValue: [],
      governmentCode: '',


    }
  },
  components:{
    Elderly,
  },

  created(){

    this.getGovList();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getGovList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data;

              if(this.governmentValue.length>0){
                this.governmentCode = this.governmentValue[0].governmentCode;
                this.getList();
              }

            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },
    govChange(val){
      this.governmentCode = val;

      this.getList(true);
    },




    getType(type){
      let data=''
      this.rechargeType_arr.forEach(element => {
        if(element.value==type){
          data=element.label
        }
      });
      return data
    },
    formatterTime(row, column, cellValue) {
      return timefilters(cellValue)
    },
    formatterTime2(cellValue) {
      return timefilters(cellValue)
    },



    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.governmentCode);
    },
    setElderly(row){
      this.elderlyCode = row.elderlyCode;
      this.elderlyName = row.name;
    },
    clearElderly(){
      this.elderlyCode = '';
      this.elderlyName = '';
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Recharge/AdmPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: this.governmentCode,
          elderlyCode:this.elderlyCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>


<style>
#printTest2 table tr th{
  border: 1px solid #ddd;padding: 0px;margin: 0px;
}
#printTest2 table tr td{
  border: 1px solid #ddd;padding: 0px;margin: 0px;
}
</style>
<style lang="scss" scoped>

</style>
